
import { default_image_src } from "../../Shared/constants/other";

const default_image = { src: default_image_src }

export default (images = [default_image], image_id) => images.find(({ id }) => id === image_id) || images[0] || default_image
